import { Injectable, inject } from '@angular/core';
import { throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { DialogServiceRenuevaSession } from '../services/dialog-Renueva.service';

@Injectable({ providedIn: 'root' })
export class HttpErrorHandler {
  private authService = inject(AuthService);
  private dialogSvc = inject(DialogServiceRenuevaSession);

  private readonly LOGIN_URL = '/login';
  private readonly SESSION_URL = '/authentication';

  handle(error: any, req: any, next: any) {
    switch (error.status) {
      case 401:
        if (req.url.includes(this.LOGIN_URL)) break;
        if (req.url.includes(this.SESSION_URL)) break;
        return this.handle401(req, next);
    }

    return throwError(() => error);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private handle401(req: any, next: any) {
    this.dialogSvc.closeall();
    return this.authService.logout();
  }
}